<template>
	<div>
		<v-btn
			class="btn-action-bar
				mx-0 my-1 pl-1
				justify-start"
			small
			@click="openAction"
		>
			<v-icon v-if="action.icon">
				{{ action.icon }}
			</v-icon>
			<img
				v-if="action.pathIcon"
				:src="action.pathIcon"
				:alt="action.name"
				class="px-1"
				height="19"
				width="25"
			/>
			<span class="action-name">{{ action.name }}</span>
		</v-btn>
	</div>
</template>

<script>
	function openAction() {
		this.$emit('open-action');
	}

	export default {
		name: 'action',
		methods: {
			openAction,
		},
		props: {
			action: {
				required: true,
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.btn-action-bar {
		background-color: white !important;
		border: 1px solid map-get($colors, default-skyblue);
		border-radius: 4px;
		border-bottom-right-radius: 0px;
		border-top-right-radius: 0px;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .5) !important;
		color: map-get($colors, default-skyblue);
		font-size: 9px !important;
		min-height: 40px;
		overflow: hidden;
		transform: translateX(-35px);
		transition: all .5s ease-in-out 0s;
		width: 113px !important;

		.action-name {
			display: inline-block;
			line-height: 1;
			max-width: 72px;
			padding: 1px 0px 0px 5px;
			text-align: left;
			text-transform: uppercase;
			white-space: pre-line;
		}

		&:hover {
			transform: translateX(-112px);
		}
	}
</style>


// WEBPACK FOOTER //
// action.vue?1d67ca8c